import { HttpClient } from '@angular/common/http';
import { inject } from '@angular/core';
import { injectLocalDialogCloseEmitter } from '@ral/ui:aui/dialog';
import { injectEnvironment } from '@ral/utils:abp';
import { aptMutationDefaultErrorHandler, AptMutationOptions } from '@ral/utils:core/data';
import { injectToastService } from '@ral/utils:core/toast';
import { injectMutation } from '@tanstack/angular-query-experimental';
import { lastValueFrom } from 'rxjs';
import { AntonycoWebNewslettersDtoSubscribeInputDto, Configuration, NewsletterService } from '../infrastructure';

export function injectNewsletterCreateMutation(
    options: AptMutationOptions<AntonycoWebNewslettersDtoSubscribeInputDto, unknown> = {
        i18n: {
            errorToastTitle: 'Odebírání newsletteru se nepodařilo odeslat',
            errorToastMessage: 'Zkuste to znovu',
        },
    }
) {
    const datasource = new NewsletterService(
        inject(HttpClient),
        injectEnvironment().getApiUrl(undefined),
        new Configuration()
    );
    const toastService = injectToastService();

    const dialogCloseEmitter = injectLocalDialogCloseEmitter();

    const defaultErrorHandler = aptMutationDefaultErrorHandler(options);

    return injectMutation(() => ({
        ...options,
        mutationFn: (input: AntonycoWebNewslettersDtoSubscribeInputDto) =>
            lastValueFrom(datasource.newsletterSubscribe(input)),
        onSuccess: async (client, variables, context) => {
            dialogCloseEmitter();
            toastService.success({
                title: 'Zapsáno',
                message: 'Na Váš email byl odeslán odkaz pro potvrzení odebírání newsletteru',
            });
            options?.onSuccess?.(client, variables, context);
        },
        onError: options?.onError ?? defaultErrorHandler,
    }));
}
